import { NgModule } from "@angular/core";

// Collections
import {
    SuiMessageModule,
    SuiPaginationModule
} from "./collections";

// Modules
import {
    SuiDropdownModule,
    SuiSearchModule,
    SuiSelectModule,
    SuiTransitionModule
} from "./modules";

// Behaviors
import {
    SuiLocalizationModule
} from "./behaviors/internal";

// Misc
import {
    SuiUtilityModule
} from "./misc";

@NgModule({
    exports: [
        // Collections
        SuiMessageModule,
        SuiPaginationModule,

        // Modules
        SuiDropdownModule,
        SuiSearchModule,
        SuiSelectModule,
        SuiTransitionModule,

        // Behaviors
        SuiLocalizationModule,

        // Misc
        SuiUtilityModule
    ]
})
export class SuiModule {}
